import { IonButton, IonModal, useIonRouter } from '@ionic/react';
import useLocalStorage from 'common/reactHooks/useLocalStorage';
import React from 'react';

interface LegalDisclaimerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Random Outcomes consent modal.
 * Layout: sticky header + scrollable body + sticky action footer so Accept
 * stays reachable when users zoom text on small Safari viewports.
 */
const LegalDisclaimer: React.FC<LegalDisclaimerProps> = ({ isOpen, onClose }) => {
  const router = useIonRouter();
  const [hasAgreedToLegalDisclaimer, setAgreedToLegalDisclaimer] = useLocalStorage<boolean>(
    'legalDisclaimer',
    false
  );

  const handleDisagree = () => {
    router.push('/logout');
  };

  const handleAgree = () => {
    setAgreedToLegalDisclaimer(true);
    onClose();
  };

  return (
    <IonModal
      isOpen={isOpen}
      backdropDismiss={false}
      className="legal-modal"
      onIonModalWillPresent={() => {
        // Blur any focused element before Ionic sets aria-hidden on the router outlet.
        // Without this, a button focused in the background (e.g. the login submit button)
        // stays focused inside the now aria-hidden ancestor, triggering a console warning:
        // "Blocked aria-hidden on an element because its descendant retained focus."
        (document.activeElement as HTMLElement | null)?.blur();
      }}
      onIonModalDidPresent={() => {
        // Move focus into the modal once it's fully open so keyboard/AT users
        // start inside the dialog, not stranded in the aria-hidden background.
        const agreeBtn = document.getElementById('agreeButton');
        agreeBtn?.focus();
      }}
    >
      <div className="legal-modal__container m-legal__form">
        <header className="legal-modal__header">
          <div className="title">Random Outcomes</div>
        </header>

        <div className="legal-modal__scroll" tabIndex={0}>
          <p className="text">
            Slot machine outcomes are determined by a random number generator (RNG) and are
            independent and unpredictable. Historical data from Slot Check is for informational
            purposes only and reflects past results. Slot Check does not predict, influence, or
            determine future outcomes. By using Slot Check, you acknowledge that it is not
            responsible for any use of this data that assumes future results can be predicted, and
            you agree to this disclaimer.
          </p>
        </div>

        <footer className="legal-modal__actions">
          <IonButton
            onClick={handleAgree}
            id="agreeButton"
            expand="block"
            class="legal-yes-button"
          >
            Yes, I agree
          </IonButton>
          <IonButton
            fill="clear"
            onClick={handleDisagree}
            id="disagreeButton"
            expand="full"
            class="legal-no-button"
          >
            No, I do not agree
          </IonButton>
        </footer>
      </div>
    </IonModal>
  );
};

export default LegalDisclaimer;
export { LegalDisclaimer };
